var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubemono = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand=youtube, monochrome=True"
  }, /*#__PURE__*/React.createElement("path", {
    id: "layer",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.385 3.184C7.984 2.939 16.011 2.938 19.615 3.184C23.516 3.451 23.971 5.815 24 12C23.971 18.196 23.512 20.55 19.615 20.816C16.011 21.062 7.985 21.061 4.385 20.816C0.484 20.549 0.029 18.185 0 12C0.029 5.804 0.488 3.45 4.385 3.184ZM9 16V8L17 11.993L9 16Z"
  }))));
};
export default SvgYoutubemono;